<div class="empty-panel"></div>

<div class="side-panel">

    <app-report-select></app-report-select>
    <form [formGroup]="searchForm" novalidate class="voffset-20" (ngSubmit)="onSubmit()">
        <div class="form-group form-horizontal">

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal ">
                        <label class="panel-label">{{ 'EnrollmentReport.DateFrom' | translate }}</label>

                        <bcui-date-picker-input2 class="date-picker" formControlName="dateFrom" name="dateFrom" hznTestId="enrollment-report-date-from"
                            inputMask="00/00/0000"
                            inputDateFormat="MM/DD/YYYY">
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'EnrollmentReport.TimeFrom' | translate }}</label>
                        <bcui-time-picker formControlName="timeFrom"></bcui-time-picker>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'EnrollmentReport.DateTo' | translate }}</label>
                        <bcui-date-picker-input2 class="date-picker" formControlName="dateTo" name="dateTo" hznTestId="enrollment-report-date-to"
                            inputMask="00/00/0000"
                            inputDateFormat="MM/DD/YYYY">
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'EnrollmentReport.TimeTo' | translate }}</label>
                        <bcui-time-picker formControlName="timeTo"></bcui-time-picker>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal ">
                        <label class="panel-label">{{ 'EnrollmentReport.SessionDateFrom' | translate }}</label>

                        <bcui-date-picker-input2 class="date-picker" formControlName="sessionDateFrom" name="dateFrom" hznTestId="enrollment-report-session-date-from"
                            inputMask="00/00/0000"
                            inputDateFormat="MM/DD/YYYY">
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'EnrollmentReport.SessionDateTo' | translate }}</label>

                        <bcui-date-picker-input2 class="date-picker" formControlName="sessionDateTo" name="dateTo" hznTestId="enrollment-report-session-date-to"
                            inputMask="00/00/0000"
                            inputDateFormat="MM/DD/YYYY">
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>



            <div class="row form-group form-horizontal">
                <div class="col-12">
                    <label class="panel-label">{{ 'EnrollmentReport.SessionName' | translate }}</label>
                    <input maxlength="200" class="form-control" formControlName="sessionName" hznTestId="enrollment-report-session-name">
                </div>
            </div>

            <div class="form-group form-horizontal voffset20">
                <label class="panel-label">{{ 'EnrollmentReport.Club' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 hznTestId="enrollment-report-club" [isDisabled]="isBusy" [options]="clubDropdownItems"
                    [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onClubsChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>

            <div class="form-group form-horizontal voffset20">
                <label class="panel-label">{{ 'EnrollmentReport.Category' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 hznTestId="enrollment-report-category" [isDisabled]="isBusy" [options]="categorieDropdownItems"
                    [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onCategoryChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>

            <div class="form-group form-horizontal voffset20">
                <label class="panel-label">{{ 'EnrollmentReport.CampType' | translate }}</label>
                <bcu-drop-down-multiselect-cf2 hznTestId="enrollment-report-camp-type" [options]="campTypeDropdownItems" [shortenWhenAllSelected]="true"
                    [selectAllOption]="true" (changed)="onCampTypeChanged($event)">
                </bcu-drop-down-multiselect-cf2>
            </div>


            <div class="row d-flex align-items-end">
                <div class="col">
                    <button class="btn btn-primary pull-right" type="submit" hznTestId="enrollment-report-search"
                        [disabled]="!isFormValid()">{{'EnrollmentReport.Search' | translate}}</button>
                    <!-- V1 hidden, the button above now uses V2
                    <button class="btn btn-secondary pull-right mr-2" type="button" hznTestId="enrollment-report-search-v2"
                        [disabled]="!isFormValid()" (click)="onSubmitV2()">{{'EnrollmentReport.SearchV2' | translate}}</button>
                    -->
                </div>
            </div>

        </div>
    </form>
</div>
